import React, { useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { getAllItems } from "../actions/itemActions";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "../actions/orderActions";

const StoreAdminDashboard = () => {
  const auth = useSelector((state) => state.auth);
  const orders = useSelector((state) => state.orders);
  const dispatch = useDispatch();
  const itemsData = async (e) => {
    dispatch(getAllItems());
  };

  const orderData = async (e) => {
    dispatch(
      getAllOrders({
        ...(auth?.user?.role === "admin" && { storeId: auth?.user?.storeId }),
        // limit: limit,
        // page: currentPageNumber,
      })
    );
  };

  useEffect(() => {
    orderData();
    itemsData();
  }, []);
  console.log(orders, "orders");

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Orders</h5>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="orders">
                      {orders?.orders?.length > 0 &&
                        orders?.orders?.map((x, i) => {
                          return (
                            <div className="order-card" key={i}>
                              <div className="order-details">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <h3>ORDER# {x?.orderNo}</h3>
                                  <div className="badge-new">Created</div>
                                </div>
                                <p>Thursday, January 30th 2025</p>
                                {x?.itemsId?.map((y, index) => {
                                  return (
                                    <>
                                      <div key={index}>
                                        <p>
                                          {y?.name
                                            ? y?.name
                                            : `Product ${index + 1}`}{" "}
                                          - {y?.sellPrice} ${" "}
                                          <div className="order-status">
                                            <span className="quantity">
                                              x {y?.quantity}
                                            </span>
                                          </div>
                                        </p>
                                      </div>
                                    </>
                                  );
                                })}
                                <p>
                                  <strong>Total:</strong> {x?.totalAmount}$
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>

                    {/* {activeTab === "Analytics" && (
                      <div className="analytics">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Analysis</th>
                                <th>Comment</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Up</td>
                                <td>Rice was good and quick service</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {activeTab === "Reviews" && (
                      <div className="reviews">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Id</th>
                                <th>From</th>
                                <th>On</th>
                                <th>Rating</th>
                                <th>Comment</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>122</td>
                                <td>Order by Abde Faisal</td>
                                <td>2/1/2025</td>
                                <td>4/5</td>
                                <td>Rice was good and quick service</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {activeTab === "Products" && (
                      <div className="products">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Id</th>
                                <th>Cover</th>
                                <th>Product Name</th>
                                <th>Price</th>
                                <th>In Stock</th>
                                <th>Rating</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>122</td>
                                <td>img</td>
                                <td>Baby Dove</td>
                                <td>120$</td>
                                <td>In stock</td>
                                <td>4(5)</td>
                                <td>
                                  <a
                                    href="#"
                                    className="btn btn-sm btn-success"
                                  >
                                    Active
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreAdminDashboard;
